import { fork } from 'redux-saga/effects'

import geolocationResetSaga from './geolocationResetSaga'
import { geolocationSaga } from '../../../integrations/geolocation'
import highlightRouteSaga from './highlightRouteSaga'
import implicitQuerySaga from './implicitQuerySaga'
import { listSaga } from '../../../integrations/list'
import mapViewSaga from './mapViewSaga'
import { routesSaga } from '../../../integrations/routes'
import searchQuerySaga from './searchQuerySaga'

/**
 * Root saga for the search app. Combines sagas for all the different user stories.
 */
export default function* searchSaga() {
    yield fork(routesSaga)
    yield fork(highlightRouteSaga)
    yield fork(mapViewSaga)
    yield fork(geolocationSaga)
    yield fork(geolocationResetSaga)
    yield fork(searchQuerySaga)
    yield fork(listSaga)
    yield fork(implicitQuerySaga)
}
